<template>
  <v-layout>
    <v-flex>
      <v-toolbar flat>
        <h3 class="font-weight-light black--text">
          
          <ModalListarGradeProduto />Entrada de Mercadoria
        </h3>
        <v-spacer></v-spacer>
        <v-btn
          outlined
          color="default"
          class="mr-2"
          @click="
            ativaModalConfirmacao({
              cor: 'yellow darken-3',
              action: 'visualizarEntradasMercadorias',
              action_value: {},
              mensagem: 'Você perderá os dados que já preencheu caso não tenha salvo, deseja realmente voltar?',
            })
          "
          >Voltar</v-btn
        >
        <v-btn
          outlined
          color="default"
          class="mr-2"
          @click="cadastrarEntradaMercadoria"
          v-if="
            getEntradaMercadoria.id &&
            $helper.verificaPermissao('cadastrar-entrada-mercadoria')
          "
          >Novo</v-btn
        >

        <v-btn
          outlined
          color="primary"
          class="mr-2"
          @click="modalSalvar = true"
          v-if="
            getEntradaMercadoria.status != 'Finalizado' &&
            ($helper.verificaPermissao('cadastrar-entrada-mercadoria') ||
              $helper.verificaPermissao('atualizar-entrada-mercadoria'))
          "
        >
          Salvar</v-btn
        >
        <v-btn
          outlined
          color="success"
          class="mr-2"
          @click="modalFinalizar = true"
          v-if="
            getEntradaMercadoria.status != 'Finalizado' &&
            ($helper.verificaPermissao('cadastrar-entrada-mercadoria') ||
              $helper.verificaPermissao('atualizar-entrada-mercadoria'))
          "
        >
          Finalizar</v-btn
        >
        <v-btn color="default" @click="cadastrarProduto()" outlined dense
          >Cadastrar Produto</v-btn
        >
        <!-- <v-btn outlined color="default" class="mr-2" @click="imprimirPedidoCompra(getEntradaMercadoria.id)"
          v-if="getEntradaMercadoria.id">
          Imprimir</v-btn> -->
      </v-toolbar>
      <v-container :fluid="true">
        <v-card outlined>
          <v-card-title>
            <h6>Pesquisar Produtos (F2)</h6>
          </v-card-title>
          <v-form class="px-3" ref="formProduto">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md2>
                  <v-text-field
                    dense
                    outlined
                    v-model="codigo_barras"
                    id="codigo_barra"
                    label="Código"
                    type="number"
                    class="ml-1 mr-1"
                    @keyup.enter="pesquisarPorCodigoDeBarras"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <!-- <v-autocomplete
                  label="Produto"
                  :items="getProdutos"
                  item-text="descricao"
                  item-value="id"
                  :search-input.sync="descricao"
                  outlined
                  v-model="getProduto.id"
                  @change="buscarProduto(getProduto.id)"
                  class="ml-3 mr-3"
                  > -->
                  <v-text-field
                    dense
                    v-model="getProduto.descricao"
                    label="Descrição"
                    outlined
                    class="ml-1 mr-1"
                    readonly
                  ></v-text-field>
                  <!-- <template v-slot:selection="data">{{data.item.descricao}} - {{data.item.marca}}</template>
                  <template v-slot:item="data">{{data.item.id}} - {{data.item.descricao}} -
                    {{data.item.marca}}</template> -->
                  <!-- </v-autocomplete> -->
                </v-flex>
                <v-flex xs12 md1>
                  <v-text-field
                    dense
                    outlined
                    v-model="quantidade"
                    @blur="somaTotalItem"
                    label="Quantidade"
                    id="quantidade"
                    @keyup.enter="focusPrecoUnitario"
                    class="ml-1 mr-1"
                    v-mask="[
                      '#,##',
                      '##,##',
                      '###,###',
                      '#.###,##',
                      '##.###,##',
                      '###.###,##',
                    ]"
                    @click="$event.target.select()"
                    :rules="rules.produto_quantidade"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md1>
                  <v-autocomplete
                    :items="getUnidadesMedidas"
                    v-model="unidade"
                    label="UN"
                    outlined
                    dense
                    class="ml-1 mr-1"
                    item-text="unidade"
                    item-value="unidade"
                    append-outer-icon="control_point"
                    @click:append-outer="cadastrarUnidadeMedida"
                    :rules="rules.produto_unidade"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 md2>
                  <v-text-field
                    dense
                    outlined
                    v-model="fator_conversao"
                    @blur="somaTotalItem"
                    label="Fator Conversão"
                    id="Fator Conversão"
                    @keyup.enter="addItemEntradaMercadoria"
                    class="ml-1 mr-1"
                    v-mask="[
                      '#,##',
                      '##,##',
                      '###,###',
                      '#.###,##',
                      '##.###,##',
                      '###.###,##',
                    ]"
                    @click="$event.target.select()"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 md2>
                  <v-text-field
                    dense
                    outlined
                    v-model="getProduto.preco_custo"
                    @blur="somaTotalItem"
                    label="Valor Total"
                    class="ml-1 mr-1"
                    @keyup.enter="addItemEntradaMercadoria"
                    id="preco_unitario"
                    v-mask="[
                      '#,##',
                      '##,##',
                      '###,###',
                      '#.###,##',
                      '##.###,##',
                      '###.###,##',
                    ]"
                    @click="$event.target.select()"
                    append-outer-icon="control_point"
                    @click:append-outer="addItemEntradaMercadoria"
                    :rules="rules.produto_preco_unitario"
                  ></v-text-field>
                </v-flex>

                <!-- <v-flex xs12 md2>
                  <v-text-field dense outlined v-model="total" label="Total" class="ml-1 mr-1" readonly
                    v-mask="['#,##', '##,##', '###,###', '#.###,##', '##.###,##', '###.###,##']"
                    append-outer-icon="control_point" @click:append-outer="addItemPedidoCompra" @click="$event.target.select()"></v-text-field>
                </v-flex> -->
              </v-layout>
            </v-card-text>
          </v-form>
        </v-card>
      </v-container>
      <v-container grid-list-xs :fluid="true">
        <v-card outlined>
          <v-card-title>
            <h6>Produtos</h6>
          </v-card-title>
          <v-card-text>
            <hr />
            <v-simple-table dense fixed-header height="400px">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Código</th>
                    <th class="text-left" width="60%">Descrição</th>
                    <th class="text-left">UN Nota</th>
                    <th class="text-left">Quant. Nota</th>
                    <!-- <th class="text-left">Fator de Conversão</th> -->
                    <th class="text-left">UN Conver.</th>
                    <th class="text-left">Quant. Conver.</th>
                    <th class="text-left">P. Unitário</th>
                    <th class="text-left">Total</th>
                    <th class="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="p in getItensEntradaMercadoria" :key="p.id">
                    <td>{{ p.produto_id }}</td>
                    <td>{{ p.descricao }}</td>
                    <td>{{ p.unidade_nota_entrada }}</td>
                    <td>{{ $helper.formatReal(parseFloat(p.quantidade_nota_entrada)) }}</td>
                    <!--<td>{{ p.fator_conversao }}</td> -->
                    <td>{{ p.unidade }}</td>
                    <td>{{ $helper.formatReal(parseFloat(p.quantidade)) }}</td>
                    <td>{{ p.preco_custo }}</td>
                    <td>{{ p.total_custo }}</td>
                    <td>
                      <v-btn
                        x-small
                        color="error"
                        @click="removeItemEntradaMercadoria(p)"
                        outlined
                      >
                        <v-icon>delete_forever</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-layout row wrap>
              <v-flex xs12 md4>
                <v-text-field
                  v-model="getEntradaMercadoria.total_produtos"
                  prefix="TOTAL DE PRODUTOS R$"
                  dense
                  outlined
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  class="mr-2 ml-2"
                  v-model="getEntradaMercadoria.desconto"
                  @input="calcDesconto"
                  append-icon="mdi-calculator"
                  @click:append="calcDesconto"
                  prefix="DESCONTO R$"
                  @click="$event.target.select()"
                  dense
                  outlined
                  v-mask="[
                    '#,##',
                    '##,##',
                    '###,###',
                    '#.###,##',
                    '##.###,##',
                    '###.###,##',
                  ]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  v-model="getEntradaMercadoria.total"
                  prefix="TOTAL R$"
                  @click="$event.target.select()"
                  dense
                  outlined
                  v-mask="[
                    '#,##',
                    '##,##',
                    '###,###',
                    '#.###,##',
                    '##.###,##',
                    '###.###,##',
                  ]"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <!-- <div style="display: flex; width: 100%">
              <v-spacer></v-spacer>
             
            </div> -->
            <hr />
            <br />
            <h4>Informações Gereais</h4>
            <v-layout row wrap class="mt-5">
              <v-flex xs12 md12>
                <v-select
                  :items="getEstoques"
                  item-text="nome"
                  item-value="id"
                  v-model="getEntradaMercadoria.estoque_id"
                  label="Estoque"
                  outlined
                  dense
                  class="ml-1 mr-1"
                ></v-select>
              </v-flex>
            </v-layout>
            <hr />
            <br />
            <h4>Infomações da Nota</h4>
            <v-layout row wrap class="mt-5">
              <v-flex xs12>
                <v-layout row wrap>
                  
                  <v-flex xs12 md2>
                    <v-text-field
                      outlined
                      dense
                      v-model="getEntradaMercadoria.numero_nota"
                      label="Nº da nota"
                      class="ml-1 mr-1"
                      id="numero_nota"
                      type="number"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 md2>
                    <v-text-field
                      outlined
                      dense
                      v-model="getEntradaMercadoria.numero_serie"
                      label="Nº de série"
                      class="ml-1 mr-1"
                      id="numero_serie"
                      type="number"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 md1>
                    <v-text-field
                      outlined
                      dense
                      v-model="getEntradaMercadoria.cfop"
                      label="CFOP"
                      class="ml-1 mr-1"
                      id="cfop"
                      v-mask="'#.###'"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 md2>
                    <v-text-field
                      type="date"
                      outlined
                      dense
                      v-model="getEntradaMercadoria.data_emissao"
                      label="Data de emissão"
                      class="ml-1 mr-1"
                      id="data_emissao"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 md2>
                    <v-text-field
                      type="date"
                      outlined
                      dense
                      v-model="getEntradaMercadoria.data_entrada"
                      label="Data Entrada"
                      class="ml-1 mr-1"
                      id="data_entrada"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      outlined
                      dense
                      v-model="getEntradaMercadoria.chave_nfe"
                      label="Chave NF-e"
                      class="ml-1 mr-1"
                      id="numero_nota"
                      type="number"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 md6>
                    <v-autocomplete
                      @click:append="cadastrarContato(true)"
                      append-icon="control_point"
                      outlined
                      dense
                      v-model="getContato.id"
                      :items="getFornecedores"
                      item-value="id"
                      item-text="nome"
                      label="Fornecedor"
                      class="ml-1 mr-1"
                      id="fornecedor"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <hr />
            <br />
            <h4>Informações do transporte</h4>
            <v-form ref="formTransportadora">
              <v-layout row wrap class="mt-5">
                <v-flex xs12 md4>
                  <v-autocomplete
                    @click:append="cadastrarContato(true)"
                    append-icon="control_point"
                    outlined
                    dense
                    v-model="getEntradaMercadoria.transportadora_id"
                    :items="getTransportadoras"
                    item-value="id"
                    item-text="nome"
                    label="Transportadora"
                    class="ml-1 mr-1"
                    id="transportadora"
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <v-select
                    :items="['CIF', 'FOB']"
                    v-model="getEntradaMercadoria.modalidade_frete"
                    label="Modalidade do Frete"
                    outlined
                    dense
                  ></v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    label="Valor do frete"
                    outlined
                    dense
                    v-mask="[
                      '#,##',
                      '##,##',
                      '###,###',
                      '#.###,##',
                      '##.###,##',
                      '###.###,##',
                    ]"
                    v-model="getEntradaMercadoria.valor_frete"
                    class="mr-1 ml-1"
                    :rules="rules.pagamento_valor"
                    @click="$event.target.select()"
                    v-if="getEntradaMercadoria.modalidade_frete == 'FOB'"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
            <hr />
            <br />
            <h4>Pagamento</h4>
            <v-form ref="formPagamento">
              <v-layout row wrap class="mt-5">
                <v-flex xs12 md1>
                  <v-text-field
                    label="Valor"
                    outlined
                    dense
                    v-mask="[
                      '#,##',
                      '##,##',
                      '###,###',
                      '#.###,##',
                      '##.###,##',
                      '###.###,##',
                    ]"
                    v-model="pagamento.valor"
                    class="mr-1 ml-1"
                    :rules="rules.pagamento_valor"
                    @click="$event.target.select()"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-autocomplete
                    :items="getContatos"
                    item-text="nome"
                    item-value="id"
                    v-model="pagamento.fornecedor"
                    outlined
                    dense
                    label="Forncedor/Transportadora"
                    :rules="rules.pagamento_fornecedor_id"
                    return-object
                  >
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12 md3>
                  <v-autocomplete
                    label="Forma de Pagamento"
                    outlined
                    dense
                    :items="getContaPagarFormasPagamento"
                    v-model="pagamento.forma_pagamento"
                    class="mr-1 ml-1"
                    :rules="rules.pagamento_forma_pagamento"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 md2>
                  <v-text-field
                    label="Data de Vencimento"
                    outlined
                    dense
                    type="date"
                    v-model="pagamento.data_vencimento"
                    class="mr-1 ml-1"
                    :rules="rules.pagamento_data_vencimento"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md2>
                  <v-autocomplete
                    label="Categoria"
                    outlined
                    dense
                    :items="getGruposFinanceiro"
                    item-text="nome"
                    v-model="pagamento.grupo_id"
                    class="mr-1 ml-1"
                    :rules="rules.pagamento_grupo_id"
                    append-outer-icon="control_point"
                    @keyup.enter="addContaPagar"
                    @click:append-outer="addContaPagar"
                    return-object
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-form>
            <v-simple-table v-if="getContasPagarEntradaMercadoria.length > 0" dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>Valor</th>
                    <th>Fornecedor/Transportadora</th>
                    <th>Forma de Pagamento</th>
                    <th>Vencimento</th>
                    <th>Categoria</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="c in getContasPagarEntradaMercadoria" :key="c.id">
                    <td>{{ c.valor }}</td>
                    <td>{{ c.fornecedor_nome }}</td>
                    <td>{{ c.forma_pagamento }}</td>
                    <td>{{ $helper.formatDate(c.data_vencimento) }}</td>
                    <td>{{ c.grupo_nome }}</td>
                    <td>
                      <v-btn
                        x-small
                        color="error"
                        @click="
                          $store.commit('removeContaPagarEntradaMercadoria', c)
                        "
                        outlined
                      >
                        <v-icon>delete_forever</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          <v-card-actions>
            <v-btn
              outlined
              color="primary"
              @click="modalSalvar = true"
              v-if="
                getEntradaMercadoria.status != 'Finalizado' &&
                ($helper.verificaPermissao('cadastrar-entrada-mercadoria') ||
                  $helper.verificaPermissao('atualizar-entrada-mercadoria'))
              "
            >
              SALVAR</v-btn
            >
            <v-btn
              outlined
              color="success"
              @click="modalFinalizar = true"
              v-if="
                getEntradaMercadoria.status != 'Finalizado' &&
                ($helper.verificaPermissao('cadastrar-entrada-mercadoria') ||
                  $helper.verificaPermissao('atualizar-entrada-mercadoria'))
              "
            >
              Finalizar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-container>
    </v-flex>

    <v-dialog v-model="modalSalvar" max-width="720">
      <v-card>
        <v-card-title>Salvar</v-card-title>
        <v-card-text>
          <h3 align="center">Tem certeza que deseja salvar?</h3>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined color="default" @click="modalSalvar = false"
            >Não</v-btn
          >
          <v-spacer></v-spacer>
          <!-- <v-btn outlined color="success" @click="getEntradaMercadoria.status = 'Finalizado', salvar()"> e Finalizar</v-btn> -->
          <v-btn
            outlined
            color="success"
            @click="(status = 'Pendente'), salvar()"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalFinalizar" max-width="720">
      <v-card>
        <v-card-title>Finalizar</v-card-title>
        <v-card-text>
          <h3 align="center">Tem certeza que deseja finalizar?</h3>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined color="default" @click="modalFinalizar = false"
            >Não</v-btn
          >
          <v-spacer></v-spacer>
          <!-- <v-btn outlined color="success" @click="getEntradaMercadoria.status = 'Finalizado', salvar()"> e Finalizar</v-btn> -->
          <v-btn
            outlined
            color="success"
            @click="(status = 'Finalizado'), salvar()"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ModalCadastroProduto v-if="getModalCadastroProduto" />
    <ModalCadastroContato v-if="getModalCadastroContato"/>
    <ModalPesquisarProduto
      @focusInputQuantidade="focusQuantidade"
      exibirPrecoCusto="true"
    
    />
    <ModalPesquisarContato />
    <ModalCadastroUnidadeMedida />
    <ModalListarGradeProduto :botaoAdicionarProduto="true"/>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ProdutoService from "@/services/ProdutoService";
import ContatoService from "@/services/ContatoService";
// import ModalExcluirOrcamento from '@/pages/orcamento/ModalExcluir'
import ModalCadastroContato from "@/pages/contato/ModalCadastro";
import ModalPesquisarContato from "@/pages/contato/ModalPesquisar";
import ModalCadastroProduto from "@/pages/produto/ModalCadastro";
import ModalPesquisarProduto from "@/pages/produto/ModalPesquisarProduto";
// import ModalImprimirOrcamento from '@/pages/orcamento/ModalImprimir'
import ModalCadastroUnidadeMedida from "@/pages/produto/unidadeMedida/ModalCadastro";
import ModalListarGradeProduto from "@/pages/produto/grade/ModalListar"
var _ = require("lodash");

export default {
  components: {
    ModalCadastroContato,
    ModalCadastroProduto,
    ModalPesquisarProduto,
    ModalPesquisarContato,
    // ModalExcluirOrcamento,
    // ModalImprimirOrcamento,
    ModalCadastroUnidadeMedida,
    ModalListarGradeProduto,
  },
  data() {
    return {
      cliente_id: 1,
      produto_id: "",
      descricao: "",
      preco: "",
      desconto: 0,
      total: "",
      codigo_barras: "",
      quantidade: "1,00",
      descontoPercentual: 0,
      descontoReal: 0,
      tabs: 0,
      modalSalvar: false,
      modalFinalizar: false,
      stauts: "Pendente",
      pagamento: {
        valor: "0,00",
        data_vencimento: "",
        data_emissao: "",
        ocorrencia: "PARCELA ÚNICA",
        grupo_id: "",
        numero_documento: "",
        forma_pagamento: "",
        ocorrencia_quantidade: 1,
        numero_parcela: 1,
        informacoes: "",
      },
      rules: {
        nome: [(v) => !!v || "Campo obrigatório."],
        produto_preco_unitario: [(v) => !!v || "Campo obrigatório."],
        produto_unidade: [(v) => !!v || "Campo obrigatório."],
        produto_quantidade: [(v) => !!v || "Campo obrigatório."],
        pagamento_valor: [(v) => !!v || "Campo obrigatório."],
        pagamento_data_vencimento: [(v) => !!v || "Campo obrigatório."],
        pagamento_forma_pagamento: [(v) => !!v || "Campo obrigatório."],
        pagamento_grupo_id: [(v) => !!v || "Campo obrigatório."],
        pagamento_fornecedor_id: [(v) => !!v || "Campo obrigatório."],
      },
      // modalImprimirOrcamento: false,
      modalConverterVendaOrcamento: false,
      opcoesResponsabilidadeFrete: ["FORNECEDOR", "CLIENTE"],
      debouncedBuscarContato: null,
      unidade: "UNID",
      fator_conversao: "0,00",
    };
  },
  computed: {
    ...mapGetters([
      "getEntradaMercadoria",
      "getItensEntradaMercadoria",
      "getProduto",
      "getProdutos",
      "getContato",
      "getContatos",
      "getTransportadoras",
      "getUnidadesMedidas",
      "getContaPagarFormasPagamento",
      "getGruposFinanceiro",
      "getContasPagarEntradaMercadoria",
      "getFornecedores",
      "getModalPesquisarProdutosOrcamento",
      "getEstoques",
      "getModalCadastroProduto",
      "getModalCadastroContato",
      "getModalPesquisarProdutoOrcamento"
    ]),
    getUnidadeMedidaProduto() {
      return this.getProduto.unidade;
    },
  },
  watch: {
    descricao: function () {
      this.debouncedPesquisarPorDescricao();
    },
    codigo_barras: function () {
      if (this.codigo_barras != "") {
        this.debouncedPesquisarPorCodigoDeBarras();
      }
    },
    quantidade: function () {
      if (this.quantidade != "" && this.quantidade != 0) {
        this.somaTotalItem();
      }
    },
    getUnidadeMedidaProduto() {
      this.unidade = this.getProduto.unidade;
    },
    getModalPesquisarProdutosOrcamento() {
      if (
        this.getModalPesquisarProdutosOrcamento == false &&
        this.getProduto.id
      ) {
        setTimeout(() => {
          this.focusQuantidade();
        }, 150);
      }
    },
    getProduto(){
      if(this.getProduto.id){
        this.unidade = this.getProduto.unidade
      }
    }
  },
  methods: {
    ...mapActions([
      "ativaModalConfirmacao",
      "cadastrarContato",
      "cadastrarProduto",
      "salvarEntradaMercadoria",
      "atualizarEntradaMercadoria",
      "buscarCliente",
      "pesquisarProdutoPorCodigoDeBarras",
      "listarProdutos",
      "listarContatos",
      "cadastrarEntradaMercadoria",
      "visualizarEntradaMercadoria",
      "visualizarProduto",
      "buscarProduto",
      "setModalPesquisarProdutosOrcamento",
      "pesquisarProduto",
      "setModalPesquisarContato",
      "setDrawer",
      "buscarContato",
      "visualizarContato",
      "setModalEnviarEmailEntradaMercadoria",
      "listarTransportadoras",
      "listarUnidadeMedida",
      "cadastrarUnidadeMedida",
      "imprimirEntradaMercadoria",
      "setModalExcluirEntradaMercadoria",
      "listarFornecedores",
      "listarGrupoFinanceiro",
      "addFormaPagamento",
      "listarEstoque",
    ]),
    calcDesconto() {
      const desconto = isNaN(
        this.$helper.cleanFormatReal(this.getEntradaMercadoria.desconto)
      )
        ? 0
        : this.$helper.cleanFormatReal(this.getEntradaMercadoria.desconto);

      if (!this.getEntradaMercadoria.total_produtos) {
        this.getUnidadeMedidaProduto.total_produtos = this.$helper.formatReal(
          this.$helper.cleanFormatReal(this.getEntradaMercadoria.total)
        );
      }

      const calc =
        this.$helper.cleanFormatReal(this.getEntradaMercadoria.total_produtos) -
        desconto;
      this.getEntradaMercadoria.total = this.$helper.formatReal(calc);
    },
    salvar() {
      if (!this.getContato.id) {
        this.getContato.id = null;
      }

      this.modalSalvar = false;
      this.modalFinalizar = false;
      this.getEntradaMercadoria.itens = this.getItensEntradaMercadoria;
      this.getEntradaMercadoria.fornecedor_id = this.getContato.id;
      this.getEntradaMercadoria.contasPagar =
        this.getContasPagarEntradaMercadoria;
      const entrada = { ...this.getEntradaMercadoria, status: this.status };

      if (this.getEntradaMercadoria.id) {
        this.atualizarEntradaMercadoria(entrada);
      } else {
        this.salvarEntradaMercadoria(entrada);
      }
    },

    somaTotalItem() {
      this.total = this.$helper.formatReal(
        parseFloat(this.quantidade) *
          this.$helper.cleanFormatReal(this.getProduto.preco_custo)
      );
    },
    addItemEntradaMercadoria() {
      if (this.$refs.formProduto.validate() === false) {
        return;
      }

      //Validade fator de conversão
      if (this.unidade != this.getProduto.unidade) {
        if (
          this.fator_conversao == "" ||
          this.$helper.cleanFormatReal(this.fator_conversao) == 0
        ) {
          this.$store.commit(
            "snackbarWarning",
            "A unidade selecionada é diferente da unidade de venda, informe o fator de conversão."
          );
          return;
        }
      }

      let quantidade = this.$helper.cleanFormatReal(this.quantidade);
      let preco_custo =
        this.$helper.cleanFormatReal(this.getProduto.preco_custo) / quantidade;
      let total_custo = this.$helper.cleanFormatReal(
        this.getProduto.preco_custo
      );

      if (
        this.fator_conversao &&
        this.$helper.cleanFormatReal(this.fator_conversao) > 0
      ) {
        quantidade =
          this.$helper.cleanFormatReal(this.quantidade) *
          this.$helper.cleanFormatReal(this.fator_conversao);
        preco_custo =
          this.$helper.cleanFormatReal(this.getProduto.preco_custo) /
          quantidade;
        total_custo = quantidade * preco_custo;
      }

      if (!this.getProduto.descricao) {
        this.$store.commit("snackbarError", "Selecione um produto.");
        return;
      }

      let item = {
        produto_id: this.getProduto.id,
        descricao: this.getProduto.descricao,
        unidade_nota_entrada: this.unidade,
        quantidade_nota_entrada: this.$helper.cleanFormatReal(this.quantidade),
        fator_conversao: this.fator_conversao,
        unidade: this.getProduto.unidade,
        preco_custo: this.$helper.formatReal(parseFloat(preco_custo)),
        quantidade: quantidade,
        total_custo: this.$helper.formatReal(parseFloat(total_custo)),
        grade_id: this.getProduto.grade_id
      };

      this.$store.commit("addItemEntradaMercadoria", item);
      this.getEntradaMercadoria.total_produtos = this.$helper.formatReal(
        parseFloat(
          this.$helper.cleanFormatReal(
            this.getEntradaMercadoria.total_produtos
          ) + this.$helper.cleanFormatReal(item.total_custo)
        )
      );

      this.getEntradaMercadoria.total =
        this.getEntradaMercadoria.total_produtos;
      this.calcDesconto();
      this.codigo_barras = "";
      this.quantidade = "1,00";
      this.produto_id = "";
      document.getElementById("codigo_barra").focus();
      this.$store.commit("setProduto", {});
      this.getProduto.unidade = "UNID";
      this.getProduto.preco_custo = "0,00";
    },
    _buscarContato() {
      this.buscarContato(this.getContato.id);
    },
    addContaPagar() {
      if (this.$helper.cleanFormatReal(this.pagamento.valor) <= 0) {
        this.$store.commit("snackbarError", "Informa o valor.");
        return;
      }

      if (this.$refs.formPagamento.validate()) {
        let item = {
          id:
            Math.random().toString(36).substring(2, 15) +
            Math.random().toString(36).substring(2, 15),
          valor: this.pagamento.valor,
          data_vencimento: this.pagamento.data_vencimento,
          data_emissao: this.getEntradaMercadoria.data_emissao,
          ocorrencia: "PARCELA ÚNICA",
          grupo_id: this.pagamento.grupo_id.id,
          grupo_nome: this.pagamento.grupo_id.nome,
          numero_documento: this.getEntradaMercadoria.numero_nota,
          forma_pagamento: this.pagamento.forma_pagamento,
          ocorrencia_quantidade: this.getContasPagarEntradaMercadoria.length,
          numero_parcela: this.numero_parcela,
          informacoes: `REF. A NOTA DE ENTRA Nº ${this.getEntradaMercadoria.numero_nota}`,
          fornecedor_id: this.pagamento.fornecedor.id,
          fornecedor_nome: this.pagamento.fornecedor.nome,
        };
        this.$store.commit("addContaPagarEntradaMercadoria", item);

        this.pagamento.valor = "0,00";
        this.pagamento.forma_pagamento = "BOLETO";
      }
    },
    removeItemEntradaMercadoria(item) {
      console.log("item", item);
      this.$store.commit("removeItemEntradaMercadoria", item);
      this.getEntradaMercadoria.total_produtos = this.$helper.formatReal(
        this.$helper.cleanFormatReal(this.getEntradaMercadoria.total_produtos) -
          this.$helper.cleanFormatReal(item.total_custo)
      );

      this.getEntradaMercadoria.total = this.$helper.formatReal(this.$helper.cleanFormatReal(this.getEntradaMercadoria.total_produtos) - this.$helper.cleanFormatReal(this.getEntradaMercadoria.desconto))
      // let total_produtos = 0;
      // this.getItensEntradaMercadoria.map((i) => {
      //   total_produtos += parseFloat(item.total_custo);
      // });
      // this.getEntradaMercadoria.total_produtos = total_produtos.toString();
    },
    pesquisarPorCodigoDeBarras() {
      if (this.codigo_barras == "") {
        document.getElementById("codigo_barra").focus();
        return;
      }

      ProdutoService.porCodigoDeBarras(this.codigo_barras)
        .then((res) => {
          if (res.data.id) {
            let produto = res.data;
            produto.preco_custo = this.$helper.formatReal(
              parseFloat(res.data.preco_custo)
            );
            // produto.total_custo = parseFloat(this.quantidade) * this.$helper.formatReal(parseFloat(res.data.preco_custo))
            this.$store.commit("setProduto", produto);
            // this.$store.commit('setItemEntradaMercadoria', produto)
            this.somaTotalItem();
            document.getElementById("quantidade").focus();
          } else {
            this.$store.commit("snackbarError", "Produto não encontado.");
            this.codigo_barras = "";
            document.getElementById("codigo_barra").focus();
          }
        })
        .catch((e) => {
          this.codigo_barras = "";
          document.getElementById("codigo_barra").focus();
          this.$store.commit("snackbarError", "Erro ao pesuisar produto.");
          console.log(e);
        });
    },
    pesquisarPorDescricao() {
      let data = {
        campo: "descricao",
        valor: this.descricao,
      };

      this.pesquisarProduto(data);
    },
    focusPrecoUnitario() {
      document.getElementById("preco_unitario").focus();
    },
    focusQuantidade() {
      // setTimeout(() => {
      document.getElementById("quantidade").focus();
      // this.somaTotalItem();
      // }, 100);
    },
    focusDescontoPercentual() {
      document.getElementById("desconto_percentual").focus();
    },
    focusCodigoDeBarra() {
      document.getElementById("codigo_barra").focus();
    },
     
    keyUp(e) {
      if (!e) e = window.event;
      let keyCode = e.keyCode || e.which;
      if (keyCode == 113) e.preventDefault();
      // if (keyCode == 114) e.preventDefault();

      if (keyCode == 113) {
        this.setModalPesquisarProdutosOrcamento(true);
      }
    },
  },
 
  created() {
    if (this.$route.params.id) {
      this.visualizarEntradaMercadoria(this.$route.params.id);
    } else {
      this.cadastrarEntradaMercadoria();
    }
    this.listarUnidadeMedida();
    this.listarFornecedores();
    this.listarTransportadoras();
    this.setModalPesquisarContato(false);
    this.listarGrupoFinanceiro();
    this.listarContatos({ id: "" });
    this.listarEstoque();
    this.debouncedPesquisarPorCodigoDeBarras = _.debounce(
      this.pesquisarPorCodigoDeBarras,
      300
    );
    this.debouncedPesquisarPorDescricao = _.debounce(
      this.pesquisarPorDescricao,
      300
    );
    this.debouncedBuscarContato = _.debounce(this._buscarContato, 500);

    document.addEventListener("keydown", this.keyUp);
  },
  beforeMount() {
    setTimeout(() => {
      this.setDrawer(false);
    }, 100);
  },
  beforeDestroy() {
    this.$store.commit("setContato", {});
    this.$store.commit("setProdutoVenda", {});
    this.$store.commit("setProduto", {});
    // this.$store.dispatch("zeraEntradaDeMercadoria")
    this.setModalPesquisarProdutosOrcamento(false);
  },
};
</script>
